/*
  Article body cleanup for WordPress-migrated posts.
  Runs once per article page:
  1. Bare YouTube URLs left behind by stripped [embed] shortcodes become
     responsive players.
  2. Images that fail to load (dead wp-content hotlinks) are hidden, along
     with their emptied wrapper.
  3. Raw iframes (old embeds) get a responsive 16:9 wrapper.
*/
(function () {
  var body = document.querySelector('.dw-article__body');
  if (!body) return;

  /* 1. Bare YouTube URLs → embeds */
  var YT = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([A-Za-z0-9_-]{11})[^\s<]*/;
  var walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT, null);
  var hits = [];
  while (walker.nextNode()) {
    var node = walker.currentNode;
    if (YT.test(node.nodeValue) && !node.parentElement.closest('a, iframe, script')) {
      hits.push(node);
    }
  }
  hits.forEach(function (node) {
    var m = node.nodeValue.match(YT);
    if (!m) return;
    node.nodeValue = node.nodeValue.replace(m[0], '').replace(/^[\s:.,–-]+/, '');
    var wrap = document.createElement('div');
    wrap.className = 'dw-article__video';
    var frame = document.createElement('iframe');
    frame.src = 'https://www.youtube-nocookie.com/embed/' + m[1];
    frame.title = 'Video';
    frame.loading = 'lazy';
    frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    frame.allowFullscreen = true;
    wrap.appendChild(frame);
    var host = node.parentElement.closest('p, li');
    if (host && body.contains(host) && host !== body) {
      host.parentNode.insertBefore(wrap, host);
      if (host.textContent.trim() === '' && !host.querySelector('img, iframe, video')) {
        host.style.display = 'none';
      }
    } else {
      /* migrated bodies often hold bare text nodes directly, so anchor to the node itself */
      node.parentNode.insertBefore(wrap, node);
    }
  });

  /* 2. Hide images that never load */
  body.querySelectorAll('img').forEach(function (img) {
    function hide() {
      img.style.display = 'none';
      var box = img.closest('figure, p');
      if (box && box.textContent.trim() === '' && !box.querySelector('img:not([style*="display: none"]), iframe, video')) {
        box.style.display = 'none';
      }
    }
    if (img.complete && img.naturalWidth === 0) hide();
    else img.addEventListener('error', hide);
  });

  /* 3. Responsive wrappers for raw embeds */
  body.querySelectorAll('iframe').forEach(function (frame) {
    if (frame.closest('.dw-article__video')) return;
    var wrap = document.createElement('div');
    wrap.className = 'dw-article__video';
    frame.parentNode.insertBefore(wrap, frame);
    wrap.appendChild(frame);
    frame.removeAttribute('width');
    frame.removeAttribute('height');
  });
})();
